// Single source of truth for the "a start date can't be after an end date" rule,
// shared by every date-range surface (trip form, journey dates, …). Mirrored on
// the backend in backend/utils/dateRange.js — keep the two in sync.

export const DATE_RANGE_MESSAGE = 'The end date can’t be before the start date.';

/**
 * Validates a start/end pair. Returns an error message when the start is strictly
 * after the end, or `null` when valid. An open-ended range (either bound missing)
 * and a same-day range (start === end) are both allowed. Inputs are date-ish
 * strings (`yyyy-mm-dd`) or null.
 */
export function validateDateRange(start?: string | null, end?: string | null): string | null {
  if (!start || !end) return null;
  const s = new Date(start);
  const e = new Date(end);
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime())) return null;
  return s.getTime() > e.getTime() ? DATE_RANGE_MESSAGE : null;
}

/** Convenience boolean: is this start/end pair valid (or open-ended)? */
export function isDateRangeValid(start?: string | null, end?: string | null): boolean {
  return validateDateRange(start, end) === null;
}
